export class Insured {
    accountNumber: string;
    cuit: string;
    documentNumber: string;
    documentType: string;
    email: string;
    firstName: string;
    fullName: string;
    gender: string;
    lastName: string;
    personType: string;
    phoneNumber: string;
    taxIVA: TaxIVA;
    electronicDocuments?: boolean;
    isValid?: boolean;

    constructor(data?: Partial<Insured>) {
        this.accountNumber = null;
        this.cuit = null;
        this.documentNumber = null;
        this.documentType = null;
        this.email = null;
        this.firstName = null;
        this.fullName = null;
        this.gender = null;
        this.lastName = null;
        this.personType = null;
        this.phoneNumber = null;
        this.taxIVA = new TaxIVA();

        if (data) {
            Object.assign(this, data);
        }
    }
}

class TaxIVA {
    key: string;
    name: string;

    constructor() {
        this.key = '';
        this.name = '';
    }
}
